import React from "react";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { SignatureView } from "./signature/SignatureView";

class App extends React.Component {
    handleSubmit() {
        alert("hello");
    }

    render() {
        return (
            <div className="app-container">
                <SignatureView />
            </div>
        );
    }
}

export default App;
